import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  CHANGE_ORDERS_REPORT_GET_JOB_LIST: createSagaAction('CHANGE_ORDERS_REPORT_GET_JOB_LIST'),
  CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST'
  ),
  CHANGE_ORDERS_REPORT_GET_FULL_REPORT: createSagaAction('CHANGE_ORDERS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  changeOrdersReportGetJobList: ({ filters }) => ({
    type: constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  changeOrdersReportGetOrganizationList: ({ filters }) => ({
    type: constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  changeOrdersReportGetFullReport: ({ filters }) => ({
    type: constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.CHANGE_ORDERS_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.CHANGE_ORDERS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.CHANGE_ORDERS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/changeOrdersReportActions.js